(function () {
function $19955ba22eaa2da9$export$ec3b168718c749cc() {
    if (!$('[data-research-section]').length) return;
    const History = window.History;
    const getPage = (href)=>{
        const querystring = href.split('?')[1];
        const parts = querystring.split('&');
        return $.grep(parts, (el)=>el.split('=')[0] === "page")[0].split('=')[1];
    };
    const getData = (page)=>{
        const authorId = $('#AuthorId').val();
        const researchSubjects = $('#product-query-container input[name="ResearchSubjects"]:checked').map((index, element)=>$(element).val()).toArray();
        const searchTerm = $('#searchTerm').val();
        return {
            AuthorId: authorId,
            ResearchSubjects: researchSubjects.join(','),
            SearchTerm: searchTerm,
            Page: page
        };
    };
    const buildUpQueryString = (data)=>{
        const authorIdDefault = $('#AuthorId option').eq(0).val();
        if (data.AuthorId === authorIdDefault && data.ResearchSubjects.length === 0 && !data.SearchTerm && data.Page <= 1) return "";
        let queryString = "";
        if (data.AuthorId !== authorIdDefault) queryString += "AuthorId=" + data.AuthorId;
        if (data.ResearchSubjects.length > 0) queryString += (queryString ? "&" : "") + "ResearchSubjects=" + data.ResearchSubjects;
        if (data.SearchTerm) queryString += (queryString ? "&" : "") + "SearchTerm=" + data.SearchTerm;
        if (data.Page > 1) queryString += (queryString ? "&" : "") + "Page=" + data.Page;
        return "?" + queryString;
    };
    $(document).on('change', '#product-query-container input, #product-query-container select', function() {
        const data = getData(1);
        History.pushState(data, $('title').html(), location.pathname + buildUpQueryString(data));
    });
    $(document).on('click', '#product-results-container .pagination a', function() {
        const href = $(this).attr('href');
        if (!href) return false;
        const page = getPage(href);
        const data = getData(page);
        History.pushState(data, $('title').html(), location.pathname + buildUpQueryString(data));
        return false;
    });
    History.Adapter.bind(window, 'statechange', ()=>{
        const State = History.getState();
        $.get('/research-search/query', State.data, (response)=>{
            $('#product-query-container').replaceWith(response);
        });
        $("#loading-message").show();
        $.get('/research-search/results', State.data, (response)=>{
            $("#loading-message").hide();
            $('#product-results-container').replaceWith(response);
        });
    });
}


$(()=>{
//setupResearchReports();
});

})();
//# sourceMappingURL=rail-review.js.map
